import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Eyebrow from "../shared/Eyebrow";
import RevealText from "../shared/RevealText";
import VideoCard from "../shared/VideoCard";
import { mediaService } from "../../services/mediaService";

export default function VideosSection() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    mediaService.list().then((list) => {
      setVideos(list.filter((m) => m.type === "youtube" && m.active));
      setLoading(false);
    });
  }, []);

  return (
    <section
      className="bg-ink py-24 md:py-32 border-t border-charcoal/50"
      data-testid="videos-section"
    >
      <div className="container-emilio">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <Eyebrow>Our Work — In Motion</Eyebrow>
            <RevealText
              as="h2"
              text={"See our team in action."}
              className="mt-4 font-display font-extrabold text-white text-display"
            />
          </div>
          <Link
            to="/our-works"
            className="inline-flex items-center gap-2 text-emerald font-semibold text-sm hover:gap-3 transition-all"
            data-testid="videos-view-all"
          >
            View All Our Works <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[0, 1, 2].map((i) => (
              <div key={i} className="aspect-video bg-charcoal/40 animate-pulse" />
            ))}
          </div>
        ) : videos.length === 0 ? (
          <div className="text-mutedtext text-center py-16 border border-charcoal">
            No videos available yet — check back soon.
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {videos.map((v) => (
              <VideoCard key={v.id} item={v} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
